export default class SearchPage {
  constructor() {
    this.selector = '.search';

    this.selectors = {
      form: '.search__form',
      filterSelect: '.search__filter-select',
    };
  }

  bootstrap() {
    const form = document.querySelector(this.selectors.form);

    if (form) {
      const filterFiled = form.querySelector(this.selectors.filterSelect);

      if (filterFiled) {
        filterFiled.addEventListener('change', () => {
          const selectedValue = filterFiled.value;
          const currentUrl = new URL(window.location.href);
          const currentSearchValue = currentUrl.searchParams.get('s');

          currentUrl.searchParams.set('cpt', selectedValue);
          currentUrl.searchParams.set('s', currentSearchValue);
          window.location.href = currentUrl.toString();
        });
      }
    }
  }
}
